module.exports = __webpack_public_path__ + "img/sup_vip_class_upgrading4.f24d25d1.jpg";